import { DatePipe } from '@angular/common';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { DTOCustomerInfo } from '../models/DTOCustomerInfo';
import { DTOParcelHistories } from '../models/DTOParcelHistories';
import { DTOPODContact } from '../models/DTOPODContact';
import { DTOShipment } from '../models/DTOShipment';
import { DTOShipmentAdvancedSearch } from '../models/DTOShipmentAdvancedSearch';
import { DTOShipmentCreate } from '../models/DTOShipmentCreate';
import { DTOShipmentCreated } from '../models/DTOShipmentCreated';
import { ApiProvider } from '../providers/api.provider';

@Injectable({
  providedIn: 'root'
})
export class ShipmentService {
  constructor(
    public apiProvider: ApiProvider,
    public datePipe: DatePipe,
    private zone: NgZone
  ) {}

  public GetShipment(
    shipmentID: number,
    userId: string,
    key: string
  ): Observable<DTOShipment> {
    return this.apiProvider.GetShipment(shipmentID, userId, key);
  }

  public UpdateShipment(
    shipment: DTOShipment,
    userId: string,
    key: string,
    reactivate: boolean
  ): Observable<boolean> {
    return this.apiProvider.UpdateShipment(shipment, userId, key, reactivate);
  }

  public GetListShipments(
    shipmentAdvancedSearch: DTOShipmentAdvancedSearch,
    userId: string,
    key: string
  ): Observable<DTOShipment[]> {
    return this.apiProvider.GetListShipments(
      shipmentAdvancedSearch,
      userId,
      key
    );
  }

  public GetPODContacts(
    shipmentId: number,
    userId: string,
    key: string
  ): Observable<DTOPODContact[]> {
    return this.apiProvider.GetPODContacts(shipmentId, userId, key);
  }

  public GetLabels(
    shipmentId: number,
    userId: string,
    key: string
  ): Observable<Blob> {
    return this.apiProvider.GetLabels(shipmentId, userId, key);
  }

  public SendPODContacts(
    shipmentId: number,
    userId: string,
    emails: string,
    key: string
  ) {
    return this.apiProvider.SendPODContacts(shipmentId, userId, emails, key);
  }

  public SearchCustomer(
    query: string,
    userId: string,
    key: string
  ): Observable<DTOCustomerInfo[]> {
    return this.apiProvider.SearchCustomer(query, userId, key);
  }

  public VoidException(
    dtoParcelHistories: DTOParcelHistories,
    userId: string,
    key: string
  ): Observable<boolean> {
    return this.apiProvider.CancelException(dtoParcelHistories, userId, key);
  }

  public CreateShipment(
    shipmentCreate: DTOShipmentCreate,
    userId: string,
    key: string
  ): Observable<DTOShipmentCreated> {
    return this.apiProvider.CreateShipment(shipmentCreate, userId, key);
  }
}
